import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
// styles
import {
  BulletedListStyled,
  ColStyled,
  LinkStyled,
  TypographyStyled,
} from '../styles';

const baseIdPrefix = 'sitemap-investments';
const baseIdSuffix = 'link';

const bulletedListConfig = [
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-investments-${baseIdSuffix}`}
        linkUrl='/investments/'
        variant='primaryDeemphasize'>
        Investments
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-brokerage-accounts-services-${baseIdSuffix}`}
        linkUrl='/investments/brokerage-accounts-services/'
        variant='primaryDeemphasize'>
        Brokerage Accounts &#38; Services
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-private-wealth-management-${baseIdSuffix}`}
        linkUrl='/private-wealth-management/'
        variant='primaryDeemphasize'>
        Private Wealth Management
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-market-commentary-${baseIdSuffix}`}
        linkUrl='/life-and-money/market-commentary/'
        variant='primaryDeemphasize'>
        Market Commentary
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-investment-advisory-services-${baseIdSuffix}`}
        linkUrl='/investments/investment-advisory-services/'
        variant='primaryDeemphasize'>
        Investment Advisory Services
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-fixed-annuity-vs-variable-annuity-${baseIdSuffix}`}
        linkUrl='/investments/fixed-annuity-vs-variable-annuity/'
        variant='primaryDeemphasize'>
        Fixed &#38; Variable Annuities
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-equities-${baseIdSuffix}`}
        linkUrl='/equities-investments/'
        variant='primaryDeemphasize'>
        Equities
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-etfs-${baseIdSuffix}`}
        linkUrl='/etfs/'
        variant='primaryDeemphasize'>
        ETFs
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-mutual-funds-${baseIdSuffix}`}
        linkUrl='/mutual-funds/'
        variant='primaryDeemphasize'>
        Mutual Funds
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-bonds-${baseIdSuffix}`}
        linkUrl='/bonds/'
        variant='primaryDeemphasize'>
        Bonds
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-cds-${baseIdSuffix}`}
        linkUrl='/cds/'
        variant='primaryDeemphasize'>
        CDS
      </Link>
    ),
  },
  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-iras-${baseIdSuffix}`}
        linkUrl='/iras-and-retirement-plans/'
        variant='primaryDeemphasize'>
        IRAs
      </Link>
    ),
  },

  {
    bulletText: (
      <Link
        id={`${baseIdPrefix}-401ks-${baseIdSuffix}`}
        linkUrl='/401k-plans/'
        variant='primaryDeemphasize'>
        401(k)s
      </Link>
    ),
  },
  {
    bulletText: (
      <>
        <LinkStyled
          id={`${baseIdPrefix}-income-annuities-${baseIdSuffix}`}
          linkUrl='/annuities/'
          variant='primaryDeemphasize'>
          Income Annuities
        </LinkStyled>
        <BulletedList
          bulletedListData={[
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-prospectus-and-reports-${baseIdSuffix}`}
                  linkUrl='/fixed-annuity-vs-variable-annuity/prospectus-and-reports/'
                  variant='primaryDeemphasize'>
                  Prospectus and Reports
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-fund-information-${baseIdSuffix}`}
                  linkUrl='/fixed-annuity-vs-variable-annuity/underlying-fund-information/'
                  variant='primaryDeemphasize'>
                  Fund Information
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-performance-history-${baseIdSuffix}`}
                  linkUrl='/fixed-annuity-vs-variable-annuity/performance-history/'
                  variant='primaryDeemphasize'>
                  Performance History
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-daily-unit-values-${baseIdSuffix}`}
                  linkUrl='/annuities/daily-unit-values/'
                  variant='primaryDeemphasize'>
                  Daily Unit Values
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id={`${baseIdPrefix}-general-investment-risk-disclosures-${baseIdSuffix}`}
                  linkUrl='/life-insurance/variable-universal-life-insurance-vul/underlying-fund-information/general-investment-risk-disclosures/'
                  variant='primaryDeemphasize'>
                  General Investment Risk Disclosures
                </Link>
              ),
            },
          ]}
          bulletType='filledCircle'
        />
      </>
    ),
  },
];

export default () => (
  <ColStyled
    medium={6}
    id='sitemap-investments-list'>
    <TypographyStyled
      component='h2'
      variant='h3'
      nextElement='typography'>
      Investments
    </TypographyStyled>
    <BulletedListStyled
      bulletedListData={bulletedListConfig}
      bulletType='none'/>
  </ColStyled>
);
